/**
 * The dashboard chip's inputs for a detail-page GroupMember — shared by the
 * combined overview tiles and the applicant switcher so both surfaces
 * render the SAME `deriveMemberChipVisual` legend the dashboard / All
 * Applications chips use (never a per-surface fork). The loader supplies
 * `member.chip` (raw status + workflow signals); without it the DERIVED
 * status stands in and the member reads as started.
 */
import type { GroupMember } from '#app/utils/application-detail-v2/types'

export function memberInitials(name: string): string {
	const parts = name.split(/\s+/).filter(Boolean)
	if (parts.length === 0) return '?'
	const selected = parts.length === 1 ? parts : [parts[0], parts.at(-1) ?? '']
	return selected.map((part) => part.charAt(0).toUpperCase()).join('')
}

export function chipInput(member: GroupMember) {
	return {
		kind:
			member.applicationType === 'guarantor'
				? ('guarantor' as const)
				: ('applicant' as const),
		status: member.chip?.status ?? member.status,
		hasStarted: member.chip?.hasStarted ?? true,
		startedAt: member.chip?.startedAt ?? null,
		infoRequested: member.chip?.infoRequested ?? false,
		billingHeld: member.chip?.billingHeld ?? false,
		initials: memberInitials(member.displayName),
	}
}
